module.exports = __webpack_public_path__ + "img/cloud-upload.2deb028a.svg";